import { TimeRange } from 'modules/Monitoring/types'
import { extendRangeToUtcDayLimits } from 'modules/Monitoring/utils/time/extendRangeToUtcDayLimits'

export const getDefaultTimeRangeParams = (): TimeRange => {
  return extendRangeToUtcDayLimits({ to: Date.now(), from: Date.now() })
}
